import React from 'react';
import { Award, Target, Zap, Shield } from 'lucide-react';
import { aboutContent } from '../data/mock';

const About = () => {
  const iconMap = {
    'Excellence': Award,
    'Integrity': Shield,
    'Innovation': Zap,
    'Commitment': Target
  };

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              {aboutContent.title}
            </h2>
            <p className="text-xl text-teal-600 font-semibold mb-6">
              {aboutContent.subtitle}
            </p>
            <div className="w-24 h-1 bg-teal-500 mx-auto"></div>
          </div>

          {/* Content Grid */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            {/* Left Column - Image Placeholder */}
            <div className="relative">
              <div className="aspect-square bg-gradient-to-br from-teal-50 to-amber-50 rounded-2xl overflow-hidden border border-slate-200">
                <div className="w-full h-full flex items-center justify-center bg-slate-100">
                  <div className="text-center p-8">
                    <div className="w-32 h-32 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Target className="w-16 h-16 text-teal-600" />
                    </div>
                    <p className="text-slate-600 font-medium">Professional IT Excellence</p>
                  </div>
                </div>
              </div>
              {/* Decorative Elements */}
              <div className="absolute -z-10 -top-4 -left-4 w-24 h-24 bg-amber-400 rounded-full opacity-20"></div>
              <div className="absolute -z-10 -bottom-4 -right-4 w-32 h-32 bg-teal-400 rounded-full opacity-20"></div>
            </div>

            {/* Right Column - Text Content */}
            <div className="space-y-6">
              <p className="text-lg text-slate-700 leading-relaxed">
                {aboutContent.description}
              </p>
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-slate-600 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          {/* Values Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {aboutContent.values.map((value, index) => {
              const IconComponent = iconMap[value.label];
              return (
                <div 
                  key={index}
                  className="bg-slate-50 border border-slate-200 rounded-xl p-6 hover:shadow-lg hover:border-teal-300 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                    <IconComponent className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{value.label}</h3>
                  <p className="text-sm text-slate-600">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
